import { useState, useEffect } from "react";
import { postUnlockTimeCapsule } from "../../../services/timeCapsuleService";
import Notiflix from "notiflix";

export default function SingleTimeCapsule({ timeCapsuleData, onBack }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [isUnlocking, setIsUnlocking] = useState(false);
  const [isUnlocked, setIsUnlocked] = useState(false);

  // Notiflix'i initialize et
  useEffect(() => {
    Notiflix.Notify.init({
      position: "top-right",
      timeout: 3000,
      clickToClose: true,
      pauseOnHover: true,
    });
  }, []);

  // Geri sayım hesaplama - API'den gelen remaining_time verisini kullan
  useEffect(() => {
    if (!timeCapsuleData?.remaining_time) return;

    // API'den gelen remaining_time verisini kullan
    const apiTimeLeft = timeCapsuleData.remaining_time;
    setTimeLeft({
      days: apiTimeLeft.days || 0,
      hours: apiTimeLeft.hours || 0,
      minutes: apiTimeLeft.minutes || 0,
      seconds: apiTimeLeft.seconds || 0
    });

    // Eğer kapsül kilitliyse gerçek zamanlı güncelleme yap
    if (!apiTimeLeft.is_unlocked) {
      const calculateTimeLeft = () => {
        const now = new Date().getTime();
        const unlockDate = new Date(timeCapsuleData.unlock_date).getTime();
        const difference = unlockDate - now;

        if (difference > 0) {
          const days = Math.floor(difference / (1000 * 60 * 60 * 24));
          const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((difference % (1000 * 60)) / 1000);

          setTimeLeft({ days, hours, minutes, seconds });
        } else {
          setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        }
      };

      calculateTimeLeft();
      const timer = setInterval(calculateTimeLeft, 1000);

      return () => clearInterval(timer);
    }
  }, [timeCapsuleData?.remaining_time, timeCapsuleData?.unlock_date]);

  // Zaman doldu mu kontrol et - remaining_time verisine göre
  const isTimeUp = timeCapsuleData?.remaining_time?.is_unlocked === true || 
                  (timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0);

  // Manuel kilit açma fonksiyonu
  const handleUnlock = async () => {
    try {
      setIsUnlocking(true);
      console.log(timeCapsuleData.uuid , "timeCapsuleData.uuid");
      const response = await postUnlockTimeCapsule(timeCapsuleData.uuid);
      
      if (response.success) {
        setIsUnlocked(true);
        Notiflix.Notify.success("Zaman kapsülü başarıyla açıldı!");
        // Kapsül verilerini güncelle
        timeCapsuleData.status = 'unlocked';
        timeCapsuleData.remaining_time.is_unlocked = true;
      } else {
        Notiflix.Notify.failure("Zaman kapsülü açılırken bir hata oluştu!");
      }
    } catch (error) {
      console.error("Kilit açma hatası:", error);
      Notiflix.Notify.failure("Zaman kapsülü açılırken bir hata oluştu!");
    } finally {
      setIsUnlocking(false);
    }
  };

  // Status unlocked ise veya zaman dolduysa içerik göster
  const canAccessContent = timeCapsuleData?.can_access_content === true || timeCapsuleData?.status === 'unlocked' || isUnlocked;
  const isJodiacUser = timeCapsuleData?.is_jodiac_user !== null && timeCapsuleData?.is_jodiac_user !== undefined;

  if (canAccessContent || isTimeUp) {
    return (
      <div className="w-full h-screen min-h-screen flex items-stretch justify-stretch sm:items-center sm:justify-center bg-gradient-to-br from-[#e8e9ed] to-[#d1d5db]">
        <div className="flex flex-col items-center w-full min-h-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-y-auto">
          
          {/* Header */}
          <div className="w-full p-6 pb-4">
            <div className="flex items-center gap-4 mb-4">
              <button
                onClick={onBack}
                className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors flex-shrink-0"
              >
                <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <div className="flex-1">
                <h1 className="text-lg font-semibold text-gray-800">
                  Zaman Kapsülü Açıldı
                </h1>
                <p className="text-xs text-gray-500 mt-0.5">
                  {timeCapsuleData?.unlock_date && new Date(timeCapsuleData.unlock_date).toLocaleDateString('tr-TR', { 
                    day: 'numeric', 
                    month: 'long', 
                    year: 'numeric' 
                  })}
                </p>
              </div>
            </div>
          </div>

          {/* Ana İçerik */}
          <div className="flex-1 pb-28 w-full flex flex-col px-6">
            {isTimeUp && !isUnlocked && timeCapsuleData?.status !== 'unlocked' && !canAccessContent && (
              <div className="flex flex-col items-center justify-center text-center">
                {/* Başlık */}
                <h1 className="text-xl font-semibold text-black mb-8 leading-tight">
                  Zaman Kapsülünüz Açıldı
                </h1>

                {/* Başarı İkonu */}
                <div className="relative mb-8">
                  <img src="/assets/pngImages/success.png" alt="Zaman Kapsülü" className="w-[245px] h-[167px]" />
                </div>

                {/* Kilit Açma Butonu */}
                <div className="mb-8 flex items-center justify-center">
                  <button
                    onClick={handleUnlock}
                    disabled={isUnlocking}
                    className={`px-8 py-4 bg-[#3DA7B5] text-white rounded-lg font-medium text-lg hover:bg-[#2A8B96] transition-colors duration-200 flex items-center space-x-2 ${
                      isUnlocking ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                  >
                    {isUnlocking ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                        <span>Açılıyor...</span>
                      </>
                    ) : (
                      <>
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
                        </svg>
                        <span>Kilidi Aç</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}

            {/* Zaman Kapsülü İçeriği - Status unlocked ise göster */}
            {canAccessContent && (
              <div className="w-full space-y-4">
                {/* Gönderen Bilgisi - Fotoğrafın Üstünde */}
                {timeCapsuleData?.sender_name && (
                  <div className="flex items-center gap-3 text-left">
                    <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-semibold text-lg flex-shrink-0 ${
                      isJodiacUser ? 'bg-gradient-to-br from-[#5abcc8] to-[#3DA7B5]' : 'bg-gradient-to-br from-gray-400 to-gray-500'
                    }`}>
                      {timeCapsuleData.sender_name.charAt(0).toUpperCase()}
                    </div>
                    <div className="flex-1 text-left">
                      <p className="text-gray-800 font-semibold text-base">
                        {timeCapsuleData.sender_name}
                      </p>
                      {isJodiacUser && (
                        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-[#5abcc8] text-white mt-1">
                          Jodiac Member
                        </span>
                      )}
                    </div>
                  </div>
                )}

                {/* Fotoğraf */}
                {timeCapsuleData?.photo_url && (
                  <div className="relative w-full h-64 rounded-2xl overflow-hidden shadow-xl">
                    <img 
                      src={timeCapsuleData.photo_url} 
                      alt="Zaman Kapsülü"
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}

                {/* İçerik Kartı */}
                <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl p-6 border border-gray-200">
                  <div className="space-y-4">
                    {/* Başlık */}
                    {timeCapsuleData?.title && (
                      <h2 className="text-left text-xl font-bold text-gray-900">
                        {timeCapsuleData.title}
                      </h2>
                    )}

                    {/* Açıklama */}
                    {timeCapsuleData?.description && (
                      <p className="text-gray-600 text-left  text-base leading-relaxed">
                        {timeCapsuleData.description}
                      </p>
                    )}

                    {/* İçerik */}
                    {timeCapsuleData?.content && (
                      <div className="pt-4 border-t border-gray-200">
                        <p className="text-gray-700 text-left text-base leading-relaxed whitespace-pre-wrap">
                          {timeCapsuleData.content}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

          </div>

          {/* Alt Boşluk */}
          <div className="h-20"></div>
        </div>
      </div>
    );
  }

  // Zaman dolmadıysa kilitli arayüzü göster
  return (
    <div className="w-full h-screen min-h-screen flex items-stretch justify-stretch sm:items-center sm:justify-center bg-[#e8e9ed]">
      <div className="flex flex-col items-center w-full min-h-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-y-auto">
        
        {/* Header */}
        <div className="w-full p-6 pb-4">
          <button
            onClick={onBack}
            className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors mb-4"
          >
            <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        </div>

        {/* Ana İçerik */}
        <div className="flex-1 flex flex-col items-center justify-center px-6 text-center">
          
          {/* Başlık */}
          <h1 className="text-2xl font-semibold text-black mb-8 leading-tight">
            Zaman Kapsülünün<br />
            Açılmasına Kalan Süre
          </h1>

          {/* Dairesel Progress */}
          <div className="relative mb-8">
            <div className="w-48 h-48 relative">
              {/* Dış halka */}
              <div className="absolute inset-0 rounded-full border-8 border-blue-100"></div>
              {/* Orta halka */}
              <div className="absolute inset-2 rounded-full border-6 border-blue-200"></div>
              {/* İç halka */}
              <div className="absolute inset-4 rounded-full border-4 border-blue-300"></div>
              
              {/* Kum saati ikonu */}
              <div className="absolute inset-0 flex items-center justify-center">
                <svg className="w-16 h-16 text-[#3DA7B5]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                  <path d="M12 6v6l4 4"/>
                </svg>
              </div>
            </div>
          </div>

          {/* Kilit İkonu */}
          <div className="mb-8">
            <svg className="w-16 h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
            </svg>
          </div>

          {/* Tarih Input'ları */}
          <div className="w-full max-w-sm">
            <div className="grid grid-cols-4 gap-3">
              {/* Gün */}
              <div className="bg-gray-100 rounded-lg px-3 py-4">
                <div className="w-full h-8 bg-gray-100 border-b-2 border-gray-300 rounded-lg flex items-center justify-center">
                  <span className="text-gray-500 text-sm">{timeLeft.days.toString().padStart(2, '0')}</span>
                </div>
                <div className="text-xs text-center mt-2 text-gray-500">Gün</div>
              </div>

              {/* Ay */}
              <div className="bg-gray-100 rounded-lg px-3 py-4">
                <div className="w-full h-8 bg-gray-100 border-b-2 border-gray-300 rounded-lg flex items-center justify-center">
                  <span className="text-gray-500 text-sm">{timeLeft.hours.toString().padStart(2, '0')}</span>
                </div>
                <div className="text-xs text-center mt-2 text-gray-500">Saat</div>
              </div>

              {/* Yıl */}
              <div className="bg-gray-100 rounded-lg px-3 py-4">
                <div className="w-full h-8 bg-gray-100 border-b-2 border-gray-300 rounded-lg flex items-center justify-center">
                  <span className="text-gray-500 text-sm">{timeLeft.minutes.toString().padStart(2, '0')}</span>
                </div>
                <div className="text-xs text-center mt-2 text-gray-500">Dakika</div>
              </div>

              {/* Saat */}
              <div className="bg-gray-100 rounded-lg px-3 py-4">
                <div className="w-full h-8 bg-gray-100 border-b-2 border-gray-300 rounded-lg flex items-center justify-center">
                  <span className="text-gray-500 text-sm">{timeLeft.seconds.toString().padStart(2, '0')}</span>
                </div>
                <div className="text-xs text-center mt-2 text-gray-500">Saniye</div>
              </div>
            </div>
          </div>

        </div>

        {/* Alt Boşluk */}
        <div className="h-20"></div>
      </div>
    </div>
  );
}